/** 
 * @packageDocumentation
 * @module ErBsClient
 **/

export enum MetaTypes {
	ActionCost = 'ActionCost',
	Area = 'Area',
	AreaSound = 'AreaSound',
	BotAiModel = 'BotAiModel',
	BotCraft = 'BotCraft',
	BotMastery = 'BotMastery',
	BotNickName = 'BotNickName',
	BotSkillBuild = 'BotSkillBuild',
	BulletCapacity = 'BulletCapacity',
	Character = 'Character',
	CharacterAttributes = 'CharacterAttributes',
	CharacterExp = 'CharacterExp',
	CharacterLevelUpStat = 'CharacterLevelUpStat',
	CharacterMastery = 'CharacterMastery',
	CharacterModeModifier = 'CharacterModeModifier',
	CharacterState = 'CharacterState',
	CharacterStateGroup = 'CharacterStateGroup',
	CharacterVoice = 'CharacterVoice',
	CharacterVoiceRandomCount = 'CharacterVoiceRandomCount',
	Collectible = 'Collectible',
	ControlTypeUse = 'ControlTypeUse',
	CriticalChance = 'CriticalChance',
	DropGroup = 'DropGroup',
	EffectAndSound = 'EffectAndSound',
	Emotion = 'Emotion',
	FootStep = 'FootStep',
	GameRankExp = 'GameRankExp',
	HookLineProjectile = 'HookLineProjectile',
	HowToFindItem = 'HowToFindItem',
	ItemArmor = 'ItemArmor',
	ItemConsumable = 'ItemConsumable',
	ItemMisc = 'ItemMisc',
	ItemSearchOption = 'ItemSearchOption',
	ItemSpawn = 'ItemSpawn',
	ItemSpecial = 'ItemSpecial',
	ItemWeapon = 'ItemWeapon',
	KeyText = 'KeyText',
	Level = 'Level',
	MasteryExp = 'MasteryExp',
	MasteryLevel = 'MasteryLevel',
	MatchingQueueTier = 'MatchingQueueTier',
	Mission = 'Mission',
	Monster = 'Monster',
	MonsterLevelUpStat = 'MonsterLevelUpStat',
	MonsterSpawnLevel = 'MonsterSpawnLevel',
	NaviCollectAndHunt = 'NaviCollectAndHunt',
	NearByArea = 'NearByArea',
	Noise = 'Noise',
	PreMadeTeamTierRestrict = 'PreMadeTeamTierRestrict',
	ProductAsset = 'ProductAsset',
	ProductCharacter = 'ProductCharacter',
	ProductInstant = 'ProductInstant',
	ProjectileSetting = 'ProjectileSetting',
	RecommendedArea = 'RecommendedArea',
	RecommendedItemList = 'RecommendedItemList',
	RecommendedList = 'RecommendedList',
	RestrictedArea = 'RestrictedArea',
	Reward = 'Reward',
	RewardItem = 'RewardItem',
	SecurityConsolEvent = 'SecurityConsolEvent',
	ServerRegion = 'ServerRegion',
	Skill = 'Skill',
	SkillEvolution = 'SkillEvolution',
	SkillEvolutionPoint = 'SkillEvolutionPoint',
	SkillExtension = 'SkillExtension',
	SkillGroup = 'SkillGroup',
	SoundGroup = 'SoundGroup',
	StartItem = 'StartItem',
	SummonObject = 'SummonObject',
	TimeOfDay = 'TimeOfDay',
	TutorialReward = 'TutorialReward',
	WeaponAnimatorLayers = 'WeaponAnimatorLayers',
	WeaponMount = 'WeaponMount',
	WeaponRoute = 'WeaponRoute',
	WeaponTypeInfo = 'WeaponTypeInfo'
}
